<template>
  <section>
    <div class="c-page-section">
      <div class="c-parts-description">
        <div class="c-parts-description__label">
          <span class="label">学校名</span>
        </div>
        <div class="c-parts-description__content">
          <h2 class="heading">{{ workLicenseListStore.schoolName }}</h2>
        </div>
      </div>
    </div>

    <div class="c-page-section -side">
      <a href="/teacher/work_license/entry/" class="c-button-white -material -prefix-icon">
        <span class="label">新しい教材を申し込む</span>
      </a>
      <div class="c-parts-toggle__wrapper modUiToggle__activeLicense">
        <div class="c-parts-toggle__text">有効なライセンスのみ表示する</div>
          <button
            type="submit"
            class="c-parts-toggle c-parts-toggle--active js-toggle"
            @click="toggleDisplayLicense"
          >
            <span class="label">ON</span>
            <span class="toggle"></span>
          </button>
      </div>
    </div>

    <div v-if="displayWorkLicenseData.length || displayCbtWorkLicenseData.length" class="c-page-section">
      <div class="c-table-explain -right">
        <copy-table-button :target-table="workLicenseTableRef" />
      </div>
      <section class="c-table-scroll-wrap">
        <div class="c-table-scroll -no-sort">
          <div class="c-table-scroll__inner">
            <table
              ref="workLicenseTableRef"
              class="c-table c-table-teacher-list"
            >
              <thead>
                <tr>
                  <th>ライセンス発行年度</th>
                  <th>教科</th>
                  <th>種別</th>
                  <th>教科書会社</th>
                  <th>教科書発行年度</th>
                  <th>教材名</th>
                  <th>利用学年</th>
                  <th>利用開始</th>
                  <th>利用終了</th>
                  <th>利用状況</th>
                </tr>
              </thead>
              <tbody>
                <!-- FIXME: NFR-2220 でソート処理を実装する -->
                <tr v-for="item in displayWorkLicenseData">
                  <td>{{ item.academicSessionYear }}</td>
                  <td>{{ item.subjectFieldName }}</td>
                  <td>
                    <template v-if="item.workType === 1">ワーク</template>
                    <template v-else-if="item.workType === 2">入試対策版</template>
                  </td>
                  <td>{{ item.publisherName }}</td>
                  <td>{{ item.textbookEdition }}</td>
                  <td>{{ item.workName }}</td>
                  <td>{{ item.academicYear }}</td>
                  <td>{{ item.startDate }}</td>
                  <td>{{ item.endDate }}</td>
                  <td>{{ item.usedStatus }}</td>
                </tr>
                <tr v-for="item in displayCbtWorkLicenseData">
                  <td>{{ item.academicSessionYear }}</td>
                  <td>{{ item.subjectFieldName }}</td>
                  <td>CBT</td>
                  <td>{{ item.publisherName }}</td>
                  <td>{{ item.textbookEdition }}</td>
                  <td>{{ item.workName }}</td>
                  <td>{{ item.academicYear }}</td>
                  <td>{{ item.startDate }}</td>
                  <td>{{ item.endDate }}</td>
                  <td>{{ item.usedStatus }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
    <div v-else style="text-align: center;">
      該当する教材ライセンスがありません。
    </div>

  </section>
</template>

<script setup lang="ts">
  import {ref, computed, onMounted} from "vue";
  import { useWorkLicenseListStore } from "@/store/teacher/work_license_list_store";

  const workLicenseListStore = useWorkLicenseListStore()

  const workLicenseTableRef = ref<HTMLTableElement | null>(null)

  // 有効なライセンスだけを表示するかのフラグ (default: True)
  // True: 有効なライセンスのみを表示
  // False: 全てのライセンスを表示
  const showActiveLicense = ref(true);

  // リストとして表示するワークの教材ラインセンスデータ
  // showActiveLicense によって切り替える
  const displayWorkLicenseData = computed(() => {
    if(workLicenseListStore.workLicenseList) {
      if(showActiveLicense.value) {
        return workLicenseListStore.workLicenseList.activeLicense;
      }
      else {
        return workLicenseListStore.workLicenseList.allLicense;
      }
    }
    return []
  })

  // リストとして表示するCBTの教材ライセンスデータ
  // showActiveLicense によって切り替える
  const displayCbtWorkLicenseData = computed(() => {
    if(workLicenseListStore.cbtWorkLicenseList) {
      if(showActiveLicense.value) {
        return workLicenseListStore.cbtWorkLicenseList.activeLicense;
      }
      else {
        return workLicenseListStore.cbtWorkLicenseList.allLicense;
      }
    }
    return []
  })

  onMounted(() => {
    // 学校ライセンス一覧を取得
    workLicenseListStore.fetchListWorkLicense()
  })

  // トグルボタン操作時の処理
  function toggleDisplayLicense() {
    // トグルボタンを操作したら有効なライセンスのみを表示するフラグを反転する
    showActiveLicense.value = !showActiveLicense.value;
  }
</script>

<style lang="scss" scoped>
.modUiToggle__activeLicense {
  margin: 0 0 0 auto;
  text-align: center;
}
</style>
